import { ca } from '@cian/analytics';

/**
 * Открытие планировки на весь экран (при клике на планировку или стрелочку)
 */
export function trackFullscreenLayoutOpen(offerId: number) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'open_layout_photo',
    category: 'card',
    label: '',
    products: [{ id: offerId }],
  });
}
